import { generateWidgetContext } from '../widget-wrapper';

export const PortfolioWidgetContext = generateWidgetContext();
